import React from 'react'

const KairaButton = ({
  name,
  type = 'button',
  label,
  disabled = false,
  onClick,
  children,
}) => {
  return (
    <button
      name={name}
      type={type}
      className={
        'w-fit flex items-center justify-center gap-2 transition-all p-[2px] rounded-[32px] border-0 overflow-hidden [background:linear-gradient(0deg,_#299D6B_6.47%,_#2A805A_91.92%)] text-white disabled:opacity-50'
      }
      onClick={onClick}
      disabled={disabled}
    >
      <div
        className={
          'flex items-center justify-center gap-2 h-full w-full rounded-[30px] py-[6px] px-[16px] [background:linear-gradient(114deg,_#299D6B_6.47%,_#2A805A_91.92%)]'
        }
      >
        {label && <p className={'text-white'}>{label}</p>}
        {children}
      </div>
    </button>
  )
}

export default KairaButton
